export const jjWorks = {
  album: [
    {
      id: 1,
      title: 'Love Tree',
      year: '2023.04.10.',
      image: require('./album/[자켓] 준재_Love Tree_자켓이미지.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=11219104#'
    }
  ]
}
